export default __webpack_public_path__ + "static/media/feature1.12e6a9e2.png";